import { createApp } from "vue"
import App from "./App.vue"
import "./registerServiceWorker"
import router from "./router"
import store from "./store"
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Tabs from 'vue3-tabs';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
//import VueFriendlyIframe from "vue-friendly-iframe"
import VueSmoothScroll from 'vue3-smooth-scroll'
import "./styles/main.scss"

createApp(App).use(store).use(router).use(Tabs).use(VueSmoothScroll).mount("#app")
